import { observer } from "mobx-react";
import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import LocalStorage from "stores/LocalStorage";
import { AuthStatus, AuthStore } from "../../../stores/AuthStore";
import { useStore } from "../../../utils/useStore";
import {
    ApplicationPaths,
    QueryParameterNames,
} from "../api-authorization/ApiAuthorizationConstants";
import AppLoadingScreen from "../AppLoadingScreen";

const AuthorizeRouteV6 = observer(({ children }: { children: JSX.Element }) => {
    const authStore = useStore(AuthStore);
    const localStore = useStore(LocalStorage);
    const connectLocal = localStore.getLocalStore("Connect");
    const location = useLocation();
    const [authorizationURI, setAuthorizationURI] = useState("");
    const [loadingAuthorizationURI, setLoadingAuthorizationURI] =
        useState(true);

    React.useEffect(() => {
        if (location) {
            authStore.setCurrentPage(location.pathname);
        }
    }, [authStore, location, location.pathname]);

    React.useEffect(() => {
        async function checkForConnect() {
            const authorization_uri = (await connectLocal.getItem(
                "authorizationURI",
            )) as string;
            setAuthorizationURI(authorization_uri);
            setLoadingAuthorizationURI(false);
        }

        checkForConnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const redirectUrl = `${ApplicationPaths.Login}?${
        QueryParameterNames.ReturnUrl
    }=${encodeURIComponent(window.location.href)}`;

    const status: AuthStatus = authStore.status;
    const authenticated: boolean = authStore._isAuthenticated;
    // const authStoreStatus = authStore.currentState;

    if (loadingAuthorizationURI) {
        return <AppLoadingScreen />;
    }


    // Redirect to the login page if the user is not authenticated
    if (!authenticated && status === AuthStatus.Initializing) {
        return <Navigate to={redirectUrl} replace />;
    }

    // Show the loading screen, if the status is not initialized
    if (status !== AuthStatus.Initialized) {
        return <AppLoadingScreen />;
    }

    // At this point, we are authenticated and the status is initialized

    // Route to the consent page if an authorization URI is present
    if (!!authorizationURI) {
        return <Navigate to={"/connect/consent"} />;
    }

    // Redirect the user to the app if they are not an admin
    if (location.pathname.includes("/admin")) {
        if (!authStore.canUserViewAdminApp()) {
            return <Navigate to={"/app"} />;
        }
    }

    // Show the route, all checks have been met
    return children;

});

export default AuthorizeRouteV6;
